<template>
  <el-form
    size="small"
    ref="editForm"
    label-position="top"
    :model="scale"
    :rules="rules"
  >

    <el-row :gutter="40">
      <el-col :span="8">
        <el-form-item label="Вес для А" prop="weight_cat_a">
          <el-input
            v-model="scale.weight_cat_a"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="Вес для B" prop="weight_cat_b">
          <el-input
            v-model="scale.weight_cat_b"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="Вес для C" prop="weight_cat_c">
          <el-input
            v-model="scale.weight_cat_c"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="40">
      <el-col :span="8">
        <el-form-item label="Допустимое" prop="min">
          <el-input
            v-model="scale.min"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="40">
      <el-col :span="8">
        <el-form-item label="Целевое" prop="fact">
          <el-input
            v-model="scale.plan"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="40">
      <el-col :span="8">
        <el-form-item label="Агрессивное" prop="max">
          <el-input
            v-model="scale.max"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="40">
      <el-col :span="8">
        <el-form-item label="Факт" prop="fact">
          <el-input
            v-model="scale.fact"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>



  </el-form>
</template>

<script>

import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";

export default {
  name: "quantity-library-edit-form",
  mixins: [],
  components: {},

  props: {
    scale: {type: Object, required: true},
  },

  computed: {},

  watch: {},

  mounted() {
    // this.$nextTick(function () {
    //   this.$refs.editForm.clearValidate();
    // });

  },

  data() {
    return {

      rules: {}

    }
  },

  methods: {

  }
}
</script>

<style>

</style>